import { MilestonePathUi, MilestonePointUi } from "ui";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";
import { OnboardingNavigationStates } from "../../../stores/hpr-hfr-dhis-onboarding/enums";

const OnboardingFlowSteps = () => {
  const activeScreen = useHprHfrOnboardingStore((state) => state.activeScreen);

  return (
    <div className="dr-p-48 dr-w-full dr-space-y-24">
      <div className="Title3Bold dr-text-darwin-touch-neutral-1000">
        Register now in 3 easy steps!
      </div>
      <div>
        <MilestonePointUi
          isCompleted={hfrCreationSteps.has(activeScreen)}
          point="1"
          title="HPR Verification"
          subtitle="Healthcare Professionals Registry"
        />
        <MilestonePathUi isCompleted={hfrCreationSteps.has(activeScreen)} />
        <MilestonePointUi
          isCompleted={hfrHprOnboardingCompletedSteps.has(activeScreen)}
          point="2"
          title="HFR Verification"
          subtitle="Healthcare Facility Registry"
        />
        <MilestonePathUi
          isCompleted={hfrHprOnboardingCompletedSteps.has(activeScreen)}
        />
        <MilestonePointUi
          point="3"
          title="Onboarding Completed"
          subtitle="All Done!"
          isCompleted={hfrHprOnboardingCompletedSteps.has(activeScreen)}
        />
      </div>
    </div>
  );
};

export default OnboardingFlowSteps;

const hfrHprOnboardingCompletedSteps = new Set([
  OnboardingNavigationStates.HFR_CREATION_COMPLETED,
]);

const hfrCreationSteps = new Set([
  ...hfrHprOnboardingCompletedSteps,
  OnboardingNavigationStates.HFR_FORM,
]);

const hprCreationSteps = new Set([
  ...hfrCreationSteps,
  OnboardingNavigationStates.LANDING,
  OnboardingNavigationStates.AADHAR,
  OnboardingNavigationStates.AADHAR_OTP,
  OnboardingNavigationStates.PHONE_NUMBER,
  OnboardingNavigationStates.PHONE_NUMBER_OTP,
  OnboardingNavigationStates.SETUP_HPR_ID,
  OnboardingNavigationStates.HPR_ID_SUCCESSFUL,
]);
